import {Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {loadIfNotLoaded} from '../../../shared/utilities/observable.utility';
import {Store} from '@ngrx/store';
import {ApplicationState} from '../../../application-state/store';
import {Order, OrderState, OrderStateRange} from '../../models';
import {OrdersSelectors, OrderStateRangesSelectors, OrderStatesSelectors} from '../../store/selectors';
import {OrderStatesActions} from '../../store';
import {ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR} from '@angular/forms';
import {extractIri} from '../../../shared/utilities/objects.utility';
import {distinctUntilChanged, takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-order-staterange-select',
  styleUrls: ['./order-staterange-select.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => OrderStaterangeSelectComponent),
    multi: true
  }],
  template: `
    <div [formGroup]="form">

      <ng-select
        [clearable]="true"
        bindValue="@id"
        bindLabel="name"
        [searchable]="true"
        [searchFn]="findItem"
        [items]="items$|async"
        [loading]="isLoading$| async"
        (touchstart)="onTouched($event)"
        formControlName="selectedElement"
        [placeholder]="'orders.orders_state_range_select.placeholder' | translate">

        <ng-template ng-label-tmp let-item="item">
          {{item.name}}

        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          {{item.name}}
        </ng-template>
      </ng-select>
    </div>
  `
})
export class OrderStaterangeSelectComponent implements OnInit, OnDestroy, ControlValueAccessor {
  form: FormGroup;
  @Output() updateSelectedObject: EventEmitter<OrderStateRange> = new EventEmitter<OrderStateRange>();

  items$: Observable<Array<OrderStateRange>>;
  isLoading$: Observable<boolean>;
  selectedItem: OrderStateRange;
  onDestroy$: Subject<any> = new Subject<any>();

  orders: Order[];
  onChange: any = () => {
  }
  onTouched: any = () => {
  }

  constructor(
    private store$: Store<ApplicationState>,
    private fb: FormBuilder,
  ) {
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      selectedElement: this.fb.control(null),
    });
    this.form.get('selectedElement').valueChanges.pipe(takeUntil(this.onDestroy$), distinctUntilChanged()).subscribe(value => {
      this.onChange(value);
    });

    this.items$ = this.store$.select(OrderStateRangesSelectors.sList);
    this.isLoading$ = this.store$.select(OrderStateRangesSelectors.isLoading);
    loadIfNotLoaded(this.store$, OrderStateRangesSelectors.isLoaded, OrderStatesActions.ReadOrderStates());
  }

  setSelectedItem(element: OrderState): void {
    this.selectedItem = element;
    this.updateSelectedObject.emit(element);
  }

  findItem(term: string, item: OrderState): boolean {
    const parts = term.split(' ');
    return parts.every(t => {
      return (item.name.toLowerCase().indexOf(t.toLowerCase()) > -1);
    });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;

  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.form.get('selectedElement').disable();
    } else {
      this.form.get('selectedElement').enable();
    }
  }

  writeValue(value: any): void {
    this.form.get('selectedElement').setValue(extractIri(value));
  }
}
